export const customStyles = {
  option: (provided, state) => ({
    ...provided,
    color: 'var(--text-color)',
    fontFamily: 'TamediaUI'
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: '#c4c5c6',
    fontFamily: 'TamediaUI'
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: 'var(--text-color)',
    fontFamily: 'TamediaUI'
  })
}

export const customStylesRed = {
  option: (provided, state) => ({
    ...provided,
    color: 'var(--text-color)',
    fontFamily: 'TamediaUI'
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: '#c4c5c6',
    fontFamily: 'TamediaUI'
  }),
  control: (provided, state) => ({
    ...provided,
    border: '1px solid #aa0a0c6b'
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: 'var(--text-color)',
    fontFamily: 'TamediaUI'
  })
}

export const customStylesBlue = {
  option: (provided, state) => ({
    ...provided,
    color: 'var(--text-color)',
    fontFamily: 'TamediaUI'
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: 'var(--text-color)',
    opacity: 0.45,
    fontFamily: 'TamediaUI'
  }),
  control: (provided, state) => ({
    ...provided,
    border: '1px solid #760507',
    backgroundColor: '#ffffff',
    cursor: 'pointer',
    borderRadius: '6px',
    outline: 'none'
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: 'var(--text-color)',
    fontFamily: 'TamediaUI'
  }),
  menuPortal: (provided, state) => ({
    ...provided,
    zIndex: 99
  }),
  groupHeading: (provided, state) => ({
    ...provided,
    fontFamily: 'TamediaUI'
  }),
  indicatorSeparator: (provided, state) => ({
    ...provided,
    background: '#cecece'
  })
}
